export default {
  "entityName": "monitor",
  id: ['monitor_id', 'protocol_id', 'site_id'],
  "pagination": {
      "itemsPerPage": 5,
      "page": 1,
      "sortBy": "protocol_id",
      "descending": true
  },
  "fields": [
      {
          "value": "protocol_id",
          "text": "Protocol",
          "type": "autocomplete",
          "title": "name",
          table: {
              sortable: true,
              filter: true,
          },
          validators: ['required'],
      },
      {
          "value": "site_id",
          "text": "Site",
          reference: 'protocol_has_site',
          id: 'site_id',
          type: 'autocomplete',
          render: item => item.site && item.site.name,
          title: 'site.name',
          subtitle: ({ site }) => `${site.city} - ${site.code}`,
          deps: ['protocol_id'],
          filter: (item, search) => {
            const filters = { protocol_id: item.protocol_id }
            if (search) {
                filters['site.name'] = [{ 'site.city': `%${search}%` }, {'site.name': `%${search}%`}, { 'site.code': `%${search}%`}]
            }
            return filters
          },
          table: {
              sortable: true,
              filter: true
          },
          readonly: item => !item.protocol_id,
          validators: ['required'],
      },
      {
        value: 'site.city',
        text: 'City',
        render: item => item.site && item.site.city,
        visible: false,
        table: {
            filter: true,
            sortable: true
        }
      },
      {
          value: 'site.code',
          text: 'Code',
          render: item => item.site && item.site.code,
          visible: false,
          table: {
              filter: true,
              sortable: true
          }
      }
  ],
  "actions": ["remove"]
}
